import { SVGProps } from "react";

export function IconDownload(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 16.0274L11.25 3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3L12.75 16.0274L17.4394 10.7517C17.7146 10.4421 18.1887 10.4143 18.4983 10.6894C18.8079 10.9646 18.8357 11.4387 18.5606 11.7483L12.5631 18.4954C12.555 18.5046 12.5467 18.5136 12.5382 18.5223C12.5295 18.5313 12.5206 18.54 12.5114 18.5486C12.3775 18.6735 12.1977 18.75 12 18.75C11.8033 18.75 11.6243 18.6743 11.4905 18.5504C11.4717 18.533 11.4539 18.5147 11.4369 18.4955L5.43944 11.7483C5.16425 11.4387 5.19213 10.9646 5.50172 10.6894C5.81131 10.4143 6.28536 10.4421 6.56055 10.7517L11.25 16.0274Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 15.75C4.91421 15.75 5.25 16.0858 5.25 16.5V20.25H18.75V16.5C18.75 16.0858 19.0858 15.75 19.5 15.75C19.9142 15.75 20.25 16.0858 20.25 16.5V20.625C20.25 21.2463 19.7463 21.75 19.125 21.75H4.875C4.25368 21.75 3.75 21.2463 3.75 20.625V16.5C3.75 16.0858 4.08579 15.75 4.5 15.75Z"
        fill="white"
      />
    </svg>
  );
}
